<template>
  <div class="maincont" id="detail_air_conditioner_monitoring">
    <div id="charts">
      <div class="ef--inner">
        <div id="air_conditioner_monitoring">
          <h2>空調自動制御監視</h2>
          <a
            href="javascript:void(0);"
            class="dlbtn2"
            @click="downloadDialog = true"
          >帳票ダウンロード</a>
          <a
            href="javascript:void(0);"
            class="dlbtn"
            @click="$router.push('/air_conditioner_detail')"
          >詳細を見る</a>

          <p class="subttl">
            <span class="select-box">
              <select v-model="monitoringType">
                <option value="1" selected="selected">日間空調自動制御監視</option>
                <option value="2">月間空調自動制御監視</option>
                <option value="3">年間月別空調自動制御監視</option>
              </select>
            </span>
          </p>

          <div class="menu_info">
            <dl class="date_info chart_display_date">
              <dt id="chart_monitoring_text">表示日時</dt>
              <dd>
                <select v-model="monitoringDate">
                  <option
                    v-for="(item, index) in monitoringList"
                    v-bind:value="item.value"
                    v-bind:key="index"
                  >{{ item.text }}</option>
                </select>
              </dd>
            </dl>

            <div class="status_info" v-bind:class="'level' + this.getControlLevel()">
              <span v-if="this.monitoringData.control_status == 0">未制御</span>
              <span v-if="this.monitoringData.control_status == 1">制御中 (限界制御)</span>
              <span v-if="this.monitoringData.control_status == 2">制御中 (注意制御)</span>
            </div>
          </div>

          <div class="monitoring_info">
            <div class="setting_info">
              <table>
                <thead>
                  <tr>
                    <th style="height:26px;" colspan="5">空調機  定格容量(全体)：<span>{{ this.monitoringData.air_conditioner_info.rating_all }}</span>kW</th>
                  </tr>
                  <tr>
                    <th style="width:20%;">台数</th>
                    <th style="width:20%;">制御子機</th>
                    <th style="width:20%;">定格容量</th>
                    <th style="width:20%;">注意制御</th>
                    <th style="width:20%;">限界制御</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><span>{{ this.monitoringData.air_conditioner_info.parent_count }}</span>台</td>
                    <td><span>{{ this.monitoringData.air_conditioner_info.child_count }}</span>台</td>
                    <td><span>{{ this.monitoringData.air_conditioner_info.rating }}</span>kW</td>
                    <td><span>{{ this.monitoringData.air_conditioner_info.max_power_caution }}</span>kW</td>
                    <td><span>{{ this.monitoringData.air_conditioner_info.max_power_limit }}</span>kW</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!------------------------------------------------------------------
            <-- 日間
            <------------------------------------------------------------------>
            <div class="control_info" v-if="this.monitoringType == 1">
              <table>
                <thead>
                  <tr>
                    <th style="width:26%;" rowspan="2">空調使用電力量</th>
                    <th style="width:26%;" rowspan="2">効果量電力量</th>
                    <th style="width:16%; height:26px;" colspan="3">デマンド削減電力</th>
                  </tr>
                  <tr>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[0].power_min }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?"10":this.monitoringData.reduced_info.reduced_data[0].power_max }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"10":this.monitoringData.reduced_info.reduced_data[1].power_min }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?"20":this.monitoringData.reduced_info.reduced_data[1].power_max }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"20":this.monitoringData.reduced_info.reduced_data[2].power_min }}kW以上
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.used_power }}</span>kWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_power }}</span>kWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[0].count }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[1].count }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[2].count }}</span>回</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!------------------------------------------------------------------
            <-- 月間
            <------------------------------------------------------------------>
            <div class="control_info" v-else-if="this.monitoringType == 2">
              <table>
                <thead>
                  <tr>
                    <th style="width:26%;" rowspan="2">空調使用電力量</th>
                    <th style="width:26%;" rowspan="2">効果量電力量</th>
                    <th style="width:16%; height:26px;" colspan="3">デマンド削減電力</th>
                  </tr>
                  <tr>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[0].power_min }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?"10":this.monitoringData.reduced_info.reduced_data[0].power_max }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"10":this.monitoringData.reduced_info.reduced_data[1].power_min }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?"20":this.monitoringData.reduced_info.reduced_data[1].power_max }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?"20":this.monitoringData.reduced_info.reduced_data[2].power_min }}kW以上
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.used_power }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_power }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[0].count }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[1].count }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?"0":this.monitoringData.reduced_info.reduced_data[2].count }}</span>回</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!------------------------------------------------------------------
            <-- 年間
            <------------------------------------------------------------------>
            <div class="control_info" v-else>
              <table>
                <thead>
                  <tr>
                    <th style="width:12%;" rowspan="2">年度</th>
                    <th style="width:20%;" rowspan="2">空調使用電力量</th>
                    <th style="width:20%;" rowspan="2">効果量電力量</th>
                    <th style="width:16%; height:26px;" colspan="3">デマンド削減電力</th>
                  </tr>
                  <tr>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[0].power_min:"0" }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[0].power_max:"10" }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[1].power_min:"10" }}
                      ～
                      {{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[1].power_max:"20" }}kW
                    </th>
                    <th style="width:16%;">
                      {{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[2].power_min:"20" }}kW以上
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ this.monitoringDate.substring(0,4) }}</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.used_power[0]:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_power:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[0].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[1].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[0].reduced_data[2].count:"0" }}</span>回</td>
                  </tr>
                  <tr>
                    <td>{{ this.monitoringDate.substring(0,4)-1 }}</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.used_power[1]:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[1].reduced_power:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[1].reduced_data[0].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[1].reduced_data[1].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[1].reduced_data[2].count:"0" }}</span>回</td>
                  </tr>
                  <tr>
                    <td>{{ this.monitoringDate.substring(0,4)-2 }}</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.used_power[2]:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[2].reduced_power:"0" }}</span>MWh</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[2].reduced_data[0].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[2].reduced_data[1].count:"0" }}</span>回</td>
                    <td style="text-align:right; padding-right:25px;"><span>{{ Array.isArray(this.monitoringData.reduced_info)?this.monitoringData.reduced_info[2].reduced_data[2].count:"0" }}</span>回</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="chart_info">
            <div class="chart_header">
              <p class="label_title" v-if="this.monitoringType == 1">空調の使用電力量および空調制御電力 (日別)</p>
              <p class="label_title" v-if="this.monitoringType == 2">空調の使用電力量および空調制御電力 (月別)</p>
              <p class="label_title" v-if="this.monitoringType == 3">空調の使用電力量および空調制御電力 (年別)</p>
              <div id="legend_info" class="legend"></div>
              <p class="label_left" v-if="this.monitoringType == 1">(kW)</p>
              <p class="label_left" v-if="this.monitoringType == 2">(kWh)</p>
              <p class="label_left" v-if="this.monitoringType == 3">(MWh)</p>
              <p class="label_right" v-if="this.monitoringType == 1">(℃)</p>
            </div>
            <div class="chart_body">
              <canvas id="monitoring_canvas"></canvas>
            </div>
          </div>

        </div>
      </div>
    </div>

    <download-dialog
      @close="downloadDialog=false"
      v-if="downloadDialog"
      :account="this.$store.state.childID"
    ></download-dialog>

  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import Store from "../store";
import DownloadDialog from "../components/AirConditionerMonitoringDownloadDialog";

export default {
  name: "air_conditioner_monitoring",
  components: {
    DownloadDialog
  },
  data: function() {
    return {
      downloadDialog: false,
      monitoringChart: null,
      monitoringType: 1,
      monitoringList: [],
      monitoringDate: "",
      monitoringData: {
        control_status: 0,
        used_power: 0,
        air_conditioner_info: {
          parent_count: 0,
          child_count: 0,
          rating: 0,
          max_power_caution: 0,
          max_power_limit: 0,
          rating_all: 0
        },
        reduced_info: {
          reduced_power: 0,
          reduced_data: [
            { power_min:  0, power_max: 10, count: 0 },
            { power_min: 11, power_max: 20, count: 0 },
            { power_min: 21, power_max:  0, count: 0 }
          ]
        },
      }
    };
  },

  watch: {
    monitoringType: function(newValue, oldValue) {
      this.monitoringType = newValue;
      if (this.monitoringType == 1) {
        $("#chart_monitoring_text").html("表示日");
        this.monitoringList = this.getMonitoringListDay();
      } else if (this.monitoringType == 2) {
        $("#chart_monitoring_text").html("表示月");
        this.monitoringList = this.getMonitoringListMonth();
      } else {
        $("#chart_monitoring_text").html("表示年");
        this.monitoringList = this.getMonitoringListYear();
      }
      this.monitoringDate = this.monitoringList[0].value;
    },

    monitoringDate: function(newValue, oldValue) {
      this.getMonitoringData();
    }
  },

  mounted: function() {
    this.monitoringType = 1;
    this.monitoringList = this.getMonitoringListDay();
    this.monitoringDate = this.monitoringList[0].value;
  },

  methods: {
    getMonitoringListDay: function() {
      let ret = [];
      let today = moment();
      today.add(1, "d");
      for (let i = 0; i < 14; i++) {
        ret.push({
          value: today.add(-1, "d").format("YYYY/MM/DD"),
          text: today.format("YYYY年MM月DD日")
        });
      }
      return ret;
    },

    getMonitoringListMonth: function() {
      let ret = [];
      let today = moment();
      today.add(1, "M");
      for (let i = 0; i < 36; i++) {
        ret.push({
          value: today.add(-1, "M").format("YYYY/MM/01"),
          text: today.format("YYYY年MM月")
        });
      }
      return ret;
    },

    getMonitoringListYear: function() {
      let ret = [];
      let today = moment();
      if (today.month() >= 3) {
        today.add(1, "y");
      }
      for (let i = 0; i < 5; i++) {
        ret.push({
          value: today.add(-1, "y").format("YYYY/04/01"),
          text: today.format("YYYY年")
        });
      }
      return ret;
    },

    getControlLevel: function() {
      let ret = 1;
      if (this.monitoringData.control_status == 1) {
        ret = 3;
      } else if (this.monitoringData.control_status == 2) {
        ret = 2;
      } else {
        ret = 1;
      }
      return ret;
    },

    getMaxKw: function() {
      let base = Math.ceil(this.monitoringData.graph_info.power_max * 1.2);
      let digit = base.toString().length;
      let round = 0;
      let ret = base;
      if (digit == 1) {
        ret = 10;
      } else if (digit == 2) {
        ret = Math.ceil(base / 10) * 10;
      } else {
        round = Math.ceil(base / (10 ** (digit - 2)));
        if (round % 10 == 0) {
          ret = Math.ceil(round * (10 ** (digit - 2)));
        } else if (round % 10 > 5) {
          ret = Math.ceil(base / (10 ** (digit - 1))) * (10 ** (digit - 1));
        } else {
          ret = (Math.floor(base / (10 ** (digit - 1))) + 0.5) * (10 ** (digit - 1));
        }
      }
      return ret;
    },

    setMonitoringGraphDay: function() {
      let dateList = [];
      let powerList = [];
      let cautionList = [];
      let limitList = [];
      let temperatureList = [];

      const self = this;

      for (let i = 0; i < this.monitoringData.graph_info.graph_data.length; i++) {
        dateList.push(this.monitoringData.graph_info.graph_data[i].date);
        powerList.push(this.monitoringData.graph_info.graph_data[i].used_power);
        temperatureList.push(this.monitoringData.graph_info.graph_data[i].temperature);
        if (this.monitoringData.graph_info.graph_data[i].control_status == 1) {
          cautionList.push(0);
          limitList.push(this.monitoringData.graph_info.graph_data[i].reduced_power);
        } else {
          cautionList.push(this.monitoringData.graph_info.graph_data[i].reduced_power);
          limitList.push(0);
        }
      }

      let minKw = this.monitoringData.graph_info.power_min;
      let maxKw = this.getMaxKw();
      let stepKw = maxKw / 10;
      let minTemperature = this.monitoringData.graph_info.temperature_min;
      let maxTemperature = this.monitoringData.graph_info.temperature_max;
      let stepTemperature = 10;

      let powerColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      powerColor.addColorStop(0, "rgba(113, 147, 255, 1)");
      powerColor.addColorStop(1, "rgba(193, 208, 255, 1)");

      let cautionColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      cautionColor.addColorStop(0, "rgba(250, 120,  43, 1)");
      cautionColor.addColorStop(1, "rgba(253, 187, 147, 1)");

      let limitColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      limitColor.addColorStop(0, "rgba(226,  33,  26, 1)");
      limitColor.addColorStop(1, "rgba(244, 168, 166, 1)");

      let chartData = {
        labels: dateList,
        datasets: [
          {
            type: "line",
            label: "気温",
            data: temperatureList,
            borderColor: "rgba(27,200,152,1.0)",
            fill: false,
            yAxisID: "y-axis-2",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "空調機デマンド",
            data: powerList,
            backgroundColor: powerColor,
            hoverBackgroundColor: powerColor,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "削減量(注意)",
            data: cautionList,
            backgroundColor: cautionColor,
            hoverBackgroundColor: cautionColor,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "削減量(限界)",
            data: limitList,
            backgroundColor: limitColor,
            hoverBackgroundColor: limitColor,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };

      let chartOption = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(param) {
          let captionList = [];
          captionList.push('<ul>');
          for (let i = 1; i < param.data.datasets.length; i++) {
            captionList.push("<li><span>");
            captionList.push(param.data.datasets[i].label);
            captionList.push("</span></li>");
          }
          captionList.push("<li><span>");
          captionList.push(param.data.datasets[0].label);
          captionList.push("</span></li>");
          captionList.push("</ul>");
          return captionList.join("");
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                maxRotation: 65,
                minRotation: 65,
                autoSkip: false,
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              stacked: true,
              ticks: {
                min: minKw,
                max: maxKw,
                stepSize: stepKw
              }
            },
            {
              id: "y-axis-2",
              type: "linear",
              position: "right",
              ticks: {
                min: minTemperature,
                max: maxTemperature,
                stepSize: stepTemperature
              }
            }
          ]
        }
      };

      if (this.monitoringChart) {
        this.monitoringChart.destroy();
      }
      this.monitoringChart = new Chart(
        document.getElementById("monitoring_canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: chartOption
        }
      );

      $("#legend_info").html(this.monitoringChart.generateLegend());
      $("#legend_info").off("click", "li");
      $("#legend_info").on("click", "li", function() {
        $(this).toggleClass("hide");
        let index = ($(this).index() + 1);
        if (index > 3) {
          index = 0;
        }
        let meta = self.monitoringChart.getDatasetMeta(index);
        meta.hidden = meta.hidden === null ? !self.monitoringChart.data.datasets[index].hidden : null;
        self.monitoringChart.update();
      });

    },
    setMonitoringGraphMonth: function() {
      let dateList = [];
      let powerList = [];
      let cautionList = [];

      const self = this;

      for (let i = 0; i < this.monitoringData.graph_info.graph_data.length; i++) {
        dateList.push(this.monitoringData.graph_info.graph_data[i].date);
        powerList.push(this.monitoringData.graph_info.graph_data[i].used_power);
        cautionList.push(this.monitoringData.graph_info.graph_data[i].reduced_power);
      }

      let minKw = this.monitoringData.graph_info.power_min;
      let maxKw = this.getMaxKw();
      let stepKw = maxKw / 10;

      let powerColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      powerColor.addColorStop(0, "rgba(113, 147, 255, 1)");
      powerColor.addColorStop(1, "rgba(193, 208, 255, 1)");

      let cautionColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      cautionColor.addColorStop(0, "rgba(250, 120,  43, 1)");
      cautionColor.addColorStop(1, "rgba(253, 187, 147, 1)");

      let chartData = {
        labels: dateList,
        datasets: [
          {
            type: "bar",
            label: "空調の使用量",
            data: powerList,
            backgroundColor: powerColor,
            hoverBackgroundColor: powerColor,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "制御による削減量",
            data: cautionList,
            backgroundColor: cautionColor,
            hoverBackgroundColor: cautionColor,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          }
        ]
      };

      let chartOption = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(param) {
          let captionList = [];
          captionList.push('<ul>');
          for (let i = 0; i < param.data.datasets.length; i++) {
            captionList.push("<li><span>");
            captionList.push(param.data.datasets[i].label);
            captionList.push("</span></li>");
          }
          captionList.push("</ul>");
          return captionList.join("");
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              stacked: true,
              ticks: {
                min: minKw,
                max: maxKw,
                stepSize: stepKw
              }
            }
          ]
        }
      };

      if (this.monitoringChart) {
        this.monitoringChart.destroy();
      }
      this.monitoringChart = new Chart(
        document.getElementById("monitoring_canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: chartOption
        }
      );

      $("#legend_info").html(this.monitoringChart.generateLegend());
      $("#legend_info").off("click", "li");
      $("#legend_info").on("click", "li", function() {
        $(this).toggleClass("hide");
        let index = $(this).index();
        let meta = self.monitoringChart.getDatasetMeta(index);
        meta.hidden = meta.hidden === null ? !self.monitoringChart.data.datasets[index].hidden : null;
        self.monitoringChart.update();
      });

    },
    setMonitoringGraphOther: function() {
      let dateList = [];
      let powerList = [];
      let cautionList = [];
      let dateListLastYear  = [];
      let powerListLastYear = [];
      let cautionListLastYear = [];
      let dateListBeforeLast = [];
      let powerListBeforeLast = [];
      let cautionListBeforeLast = [];

      const self = this;

      for(let i = 0; i < this.monitoringData.graph_info.graph_dataBeforeLast.length; i++) {
        dateListBeforeLast.push(this.monitoringData.graph_info.graph_dataBeforeLast[i].date);
        powerListBeforeLast.push(this.monitoringData.graph_info.graph_dataBeforeLast[i].used_power);
        cautionListBeforeLast.push(this.monitoringData.graph_info.graph_dataBeforeLast[i].reduced_power);
      }

      for(let i = 0; i < this.monitoringData.graph_info.graph_dataLastYear.length; i++) {
        dateListLastYear.push(this.monitoringData.graph_info.graph_dataLastYear[i].date);
        powerListLastYear.push(this.monitoringData.graph_info.graph_dataLastYear[i].used_power);
        cautionListLastYear.push(this.monitoringData.graph_info.graph_dataLastYear[i].reduced_power);
      }

      for (let i = 0; i < this.monitoringData.graph_info.graph_data.length; i++) {
        dateList.push(this.monitoringData.graph_info.graph_data[i].date);
        powerList.push(this.monitoringData.graph_info.graph_data[i].used_power);
        cautionList.push(this.monitoringData.graph_info.graph_data[i].reduced_power);
      }

      let minKw = this.monitoringData.graph_info.power_min;
      let maxKw = this.getMaxKw();
      let stepKw = maxKw / 10;

      let powerColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      powerColor.addColorStop(0, "rgba(113, 147, 255, 1)");
      powerColor.addColorStop(1, "rgba(193, 208, 255, 1)");

      let cautionColor = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      cautionColor.addColorStop(0, "rgba(250, 120,  43, 1)");
      cautionColor.addColorStop(1, "rgba(253, 187, 147, 1)");

      let powerColor2 = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      powerColor2.addColorStop(0, "rgba(167, 167, 167, 1)");
      powerColor2.addColorStop(1, "rgba(230, 230, 230, 1)");

      let cautionColor2 = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      cautionColor2.addColorStop(0, "rgba(250, 170,  93, 1)");
      cautionColor2.addColorStop(1, "rgba(253, 207, 167, 1)");

      let powerColor3 = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      powerColor3.addColorStop(0, "rgba(199, 199, 199, 1)");
      powerColor3.addColorStop(1, "rgba(240, 240, 240, 1)");

      let cautionColor3 = document.getElementById("monitoring_canvas").getContext("2d").createLinearGradient(0, 0, 0, 380);
      cautionColor3.addColorStop(0, "rgba(250, 220, 143, 1)");
      cautionColor3.addColorStop(1, "rgba(253, 227, 187, 1)");

      let chartData = {
        labels: dateList,
        datasets: [
          {
            type: "bar",
            label: "空調の使用量",
            data: powerList,
            backgroundColor: powerColor,
            hoverBackgroundColor: powerColor,
            stack: "one",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "制御による削減量",
            data: cautionList,
            backgroundColor: cautionColor,
            hoverBackgroundColor: cautionColor,
            stack: "one",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            label: "",
            stack: "one",
            data: []
          },
          {
            type: "bar",
            label: "去年空調の使用量",
            data: powerListLastYear,
            backgroundColor: powerColor2,
            hoverBackgroundColor: powerColor2,
            stack: "two",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "去年制御による削減量",
            data: cautionListLastYear,
            backgroundColor: cautionColor2,
            hoverBackgroundColor: cautionColor2,
            stack: "two",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            label: "",
            stack: "two",
            data: []
          },
          {
            type: "bar",
            label: "一昨年空調の使用量",
            data: powerListBeforeLast,
            backgroundColor: powerColor3,
            hoverBackgroundColor: powerColor3,
            stack: "three",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            type: "bar",
            label: "一昨年制御による削減量",
            data: cautionListBeforeLast,
            backgroundColor: cautionColor3,
            hoverBackgroundColor: cautionColor3,
            stack: "three",
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointHitRadius: 0
          },
          {
            label: "",
            stack: "three",
            data: []
          }
        ]
      };

      let chartOption = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(param) {
          var captionList = [], h1 = "", h2 = "";
          h1 += '<div><ul class="' + param.id + '-legend">';
          h2 += '<div style="margin-top: 10px;"><ul class="' + param.id + '-legend">';
          for (let i = 0; i < param.data.datasets.length; i++) {
            if (param.data.datasets[i].label){
              if (param.data.datasets[i].label.includes("削減量")) {
                h2 += "<li id='year-2-legend'><span>";
                h2 += param.data.datasets[i].label;
                h2 += "</span></li>"
              } else {
                h1 += "<li id='year-1-legend'><span>";
                h1 += param.data.datasets[i].label;
                h1 += "</span></li>";
              }
            }
          }
          h1 += "</ul></div>";
          h2 += "</ul></div>";
          captionList.push(h1);
          captionList.push(h2);
          return captionList.join("");
        },
        scales: {
          xAxes: [
            {
              stacked: true,
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              stacked: true,
              ticks: {
                min: minKw,
                max: maxKw,
                stepSize: stepKw
              }
            }
          ]
        },
        tooltips: {
          mode: 'x',
          filter: function (tooltipItem) {
            if (tooltipItem.value > 0) {
              return true;
            }
          },
          callbacks: {
            title: (tooltipItem, data) => {
              if (tooltipItem[0].datasetIndex == 0 || tooltipItem[0].datasetIndex == 1) {
                return dateList[tooltipItem[0].index];
              } else if (tooltipItem[0].datasetIndex == 3 || tooltipItem[0].datasetIndex == 4) {
                return dateListLastYear[tooltipItem[0].index];
              } else if (tooltipItem[0].datasetIndex == 6 || tooltipItem[0].datasetIndex == 7) {
                return dateListBeforeLast[tooltipItem[0].index];
              }
            }
          }
        }
      };

      if (this.monitoringChart) {
        this.monitoringChart.destroy();
      }
      this.monitoringChart = new Chart(
        document.getElementById("monitoring_canvas").getContext("2d"),
        {
          type: "bar",
          data: chartData,
          options: chartOption
        }
      );

      $("#legend_info").html(this.monitoringChart.generateLegend());
      $("#legend_info").off("click", "li");
      $("#legend_info").on("click", "li", function() {
        $(this).toggleClass("hide");
        let index = $(this).index();
        console.table(index)
        if (this.id.includes("1")) {
          index = 3 * index;
        } else if (this.id.includes("2")) {
          index = 3 * index + 1;
        }
        console.table(index)
        let meta = self.monitoringChart.getDatasetMeta(index);
        meta.hidden = meta.hidden === null ? !self.monitoringChart.data.datasets[index].hidden : null;
        self.monitoringChart.update();
      });

    },

    getMonitoringData: function() {
      let api = "";
      if (this.monitoringType == 1) {
        api = "air_conditioner_monitoring_day_screen";
      } else if (this.monitoringType == 2) {
        api = "air_conditioner_monitoring_month_screen";
      } else {
        api = "air_conditioner_monitoring_year_screen";
      }
      this.$axios
        .post(`/srv/api/${api}/${this.$store.state.childID}`,
              { date: this.monitoringDate },
              { withCredentials: true }
        )
        .then(response => {
          console.log(response.data);
          this.monitoringData = response.data;
          if (this.monitoringType == 1) {
            this.setMonitoringGraphDay();
          } else if(this.monitoringType == 2) {
            this.setMonitoringGraphMonth();
          } else {
            this.setMonitoringGraphOther();
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
